import styled, { css } from 'styled-components';

import {
    spaceMixin,
    token,
} from '@zillow/constellation';

const TYPE = {
    INFO: 'info',
    NEUTRAL: 'neutral',
    SUCCESS: 'success',
    WARN: 'warn',
    CAUTION: 'caution',
    IN_PROGRESS: 'in_progress',
};

const greenDark = '#055e16';
const greyDark = '#596b82';
const purpleDark = '#5b33ad';
const yellowDark = '#915d00';
const redDark = token('colors.red600');
const blueDark = token('colors.blue500');

const getStatusByType = ({ type }) => {
    switch (type.toLowerCase()) {
        case TYPE.INFO:
            return css`
                color: ${purpleDark};
                background-color: ${token('colors.purple100')};
            `;
        case TYPE.SUCCESS:
            return css`
                color: ${greenDark};
                background-color: ${token('colors.green100')};
            `;
        case TYPE.WARN:
            return css`
                color: ${yellowDark};
                background-color: ${token('colors.yellow100')};
            `;
        case TYPE.CAUTION:
            return css`
                color: ${redDark};
                background-color: ${token('colors.red100')};
            `;
        case TYPE.IN_PROGRESS:
            return css`
                color: ${blueDark};
                background-color: ${token('colors.blue200')};
            `;

        // fall through
        case TYPE.NEUTRAL:
        default:
            return css`
                color: ${greyDark};
                background-color: ${token('colors.gray200')};
            `;
    }
};

const getFontStyling = ({ size }) => {
    switch (size.toLowerCase()) {
        case 'sm':
            return css`
                line-height: 16px;
                font-size: 12px;
            `;
        case 'md':
            return css`
                line-height: 24px;
                font-size: 14px;
            `;
        default:
            return css`
                line-height: 24px;
                font-size: 14px;
            `;
    }
};

export const StyledStatus = styled.div`
    display: inline-block;
    padding: 3px ${spaceMixin('xs')};
    
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 4px;

    ${getStatusByType}

    & > .ConnectedStatus-StatusText {
        ${getFontStyling}
    }
`;
